import React from 'react';
import { Button, Stack } from '@mui/material';
import { AddCircle } from '@mui/icons-material';
import { ProductConfigListingContext } from '../../../types';

interface Props {
  context: ProductConfigListingContext;
}

export const TopActionPanel = ({ context }: Props) => {
  return (
    <Stack direction="row" gap="0.5rem">
      <Button
        onClick={context.onAddConfigurationColumn}
        startIcon={<AddCircle />}
        size="small"
        disabled={context.isReadOnly}
      >
        Add condition
      </Button>
    </Stack>
  );
};
